import logger from 'utils/logger';
import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to Spanish
    try {
      const savedLanguage = localStorage.getItem('appLanguage');
      return savedLanguage || 'es';
    } catch (error) {
      logger.error('Error reading language from localStorage:', error);
      return 'es';
    }
  });

  const changeLanguage = (lang) => {
    try {
      setLanguage(lang);
      localStorage.setItem('appLanguage', lang);
    } catch (error) {
      logger.error('Error saving language to localStorage:', error);
    }
  };

  useEffect(() => {
    // Update document language attribute for accessibility
    document.documentElement.lang = language;
  }, [language]);

  const value = {
    language,
    changeLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
